import { render, staticRenderFns } from "./InfoPlayer.vue?vue&type=template&id=bc337012"
import script from "./InfoPlayer.vue?vue&type=script&lang=js"
export * from "./InfoPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports